import { useEffect, useRef } from 'react';
import { gql } from '@yi/core';
import { MembershipTierWithAnon } from '@yi/core/src/types/MembershipTierWithAnon';

import { sendPageView } from './sendPageView';

export type PageViewData = Parameters<typeof sendPageView>[0]['pageViewData'];

interface Args {
  loading: boolean;
  currentUser: gql.typesClient.Query_CurrentUser_CurrentUser | null;
  pageViewData?: PageViewData;
  tier: MembershipTierWithAnon | null;
}

/***
 * This hook addresses an issue where `currentUser` was being updated with each call to
 * `logConsumptionTracking`, resulting in a page view event being sent every minute.
 */
export const useSendPageViewAnalytics = ({ loading, currentUser, pageViewData, tier }: Args) => {
  const lastKeyRef = useRef('');

  useEffect(() => {
    if (loading) return;

    const key = `${tier}|${currentUser?.id}|${pageViewData?.contentId}`;
    if (lastKeyRef.current === key) return; // prevent sending duplicate page views
    lastKeyRef.current = key;

    sendPageView({ currentUser, pageViewData, tier });
  }, [loading, currentUser, pageViewData, tier]);
};
